var _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 17.5,
    width: 6,
    height: 6,
    fill: "white",
    stroke: "#2C3038"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 28.5,
    width: 6,
    height: 6,
    fill: "white",
    stroke: "#2C3038"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 21,
    width: 2,
    height: 15,
    transform: "rotate(-90 11 21)",
    fill: "#2C3038"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17,
    width: 2,
    height: 16,
    fill: "#2C3038"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 33,
    width: 2,
    height: 9,
    transform: "rotate(-90 11 33)",
    fill: "#2C3038"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5H10V9H6V11H10V15H12V11H16V9H12V5Z",
    fill: "#F87B0E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/node.79efd6c989326e315fd38c6fa2a68f09.svg";